import { Loader } from 'components/Loader/Loader';
import { MatchList } from 'components/MatchList/MatchList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getHighlights,
  getLastMinuteEvents,
} from 'services/api/sportBetsService';
import { MatchOffer } from 'types/MatchOffer';
import useAsyncEffect from 'use-async-effect';

export const DefaultSection = () => {
  const [lastMinuteMatches, setLastMinuteMatches] = useState<
    MatchOffer[] | null
  >(null);
  const [highlihts, setHighLihts] = useState<MatchOffer[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useAsyncEffect(async () => {
    setIsLoading(true);
    const lastMinutePromise = getLastMinuteEvents();
    const highlightsPromise = getHighlights();

    const [lastMinuteResp, highlightsResp] = await Promise.all([
      lastMinutePromise,
      highlightsPromise,
    ]);
    setIsLoading(false);

    setLastMinuteMatches(lastMinuteResp);
    setHighLihts(highlightsResp);
  }, []);

  const { t } = useTranslation();

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {highlihts && highlihts.length > 0 && (
            <MatchList
              events={highlihts}
              leagueName={t('highlights_label')}
              hideBetFilter
            />
          )}
          {lastMinuteMatches && lastMinuteMatches.length > 0 && (
            <MatchList
              events={lastMinuteMatches}
              leagueName={t('last_minute_events_label')}
              hideBetFilter
            />
          )}
        </>
      )}
    </>
  );
};
